import { render, staticRenderFns } from "./IntonationReadingForm.vue?vue&type=template&id=1c88c398&"
import script from "./IntonationReadingForm.vue?vue&type=script&lang=js&"
export * from "./IntonationReadingForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports